const getCompareSeriesRefId = (refId) => `${refId}-compare`;

export { getCompareSeriesRefId };
//# sourceMappingURL=getCompareSeriesRefId.js.map
